import axios from '../utilities/axios'
import { getCaptchaToken } from '../utilities/googleCaptcha.util'

async function handleTicket(ticket) {
  const captchaToken = await getCaptchaToken('support')
  const formData = new FormData()
  formData.append('supportName', ticket.supportName)
  formData.append('supportEmail', ticket.supportEmail)
  formData.append('supportQuestionType', ticket.supportQuestionType)
  if (ticket.supportCouponCode) {
    formData.append('supportCouponCode', ticket.supportCouponCode)
  }
  formData.append('supportQuestion', ticket.supportQuestion)
  if (ticket.supportFiles) {
    ticket.supportFiles.forEach(file => formData.append('file', file))
  }
  formData.append('captchaToken', captchaToken)
  formData.append('supportTicketType', 'support')

  return axios.post('/api/v1/support', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

async function handlePoP(ticket) {
  const captchaToken = await getCaptchaToken('support')
  const formData = new FormData()
  formData.append('popName', ticket.popName)
  formData.append('popEmail', ticket.popEmail)
  formData.append('popDateOfPurchase', JSON.stringify(ticket.popDateOfPurchase))
  formData.append('popPurchaseFromRetailer', ticket.popPurchaseFromRetailer)
  formData.append('popCountryOfPurchase', ticket.popCountryOfPurchase)
  formData.append('numberOfHardware', ticket.numberOfHardware)
  for (let index = 1; index <= ticket.numberOfHardware; index++) {
    const hardwareType = ticket[`popHardwareType${index}`]
    const hardwareReceipt = ticket[`popHardwareReceipt${index}`]
    formData.append(`popHardwareType${index}`, hardwareType)
    formData.append(`popHardwareReceipt${index}`, hardwareReceipt)
  }
  if (ticket.popCouponCode) {
    formData.append('popCouponCode', ticket.popCouponCode)
  }
  if (ticket.popComments) {
    formData.append('popComments', ticket.popComments)
  }
  if (ticket.popSupportFiles) {
    ticket.popSupportFiles.forEach(file => formData.append('file', file))
  }
  formData.append('captchaToken', captchaToken)
  formData.append('supportTicketType', 'proofOfPurchase')

  return axios.post('/api/v1/support', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

async function getSuggestions() {
  return axios.get('/api/v1/support/suggestion')
}

export default {
  handleTicket,
  handlePoP,
  getSuggestions,
}
